export const SET_USER = 'setUser'
export const SET_AUTH = 'setAuth'
export const PURGE_AUTH = 'purgeAuth'
export const SET_ERROR = 'setError'
